import classNames from 'classnames';
import React from 'react';

import {FunnelLogContextProvider} from '@udemy/funnel-tracking';
import {
    MyLearningUnit,
    MyLearningUnitProps,
    MyLearningUnitTabProvider,
} from '@udemy/react-my-learning-unit';

import {UserEnrollmentsData} from 'src/types/page-props';

interface MyLearningUnitSectionProps {
    tabs: MyLearningUnitProps['learningTabs'];
    title: string;
    /** When omitted, each tab renders its own built-in empty-state UI instead. */
    noContentTitle?: string;
    url: string;
    preloadedData?: UserEnrollmentsData;
    className?: string;
}

/**
 * Shared rendering shell for the MyLearningUnit on logged-in home pages.
 *
 * Wraps FunnelLogContextProvider → MyLearningUnitTabProvider → MyLearningUnit.
 * Tab construction (which tabs to show and under what conditions) is the responsibility
 * of the caller; this component only handles the rendering infrastructure.
 *
 * `noContentTitle` is shown when all tabs have loaded but contain no items —
 * the unit remains visible to encourage the user to start learning.
 */
export const MyLearningUnitSection = ({
    tabs,
    title,
    noContentTitle,
    url,
    preloadedData,
    className,
}: MyLearningUnitSectionProps) => {
    return (
        <div className={classNames('component-margin', className)}>
            <FunnelLogContextProvider pageType="logged_in_homepage">
                <MyLearningUnitTabProvider learningTabs={tabs}>
                    <MyLearningUnit
                        title={title}
                        noContentTitle={noContentTitle}
                        url={url}
                        learningTabs={tabs}
                        disableLoadingStates={!!preloadedData}
                        {...(preloadedData && {preloadedData: {data: preloadedData}})}
                    />
                </MyLearningUnitTabProvider>
            </FunnelLogContextProvider>
        </div>
    );
};
